import AccessibilityIcon from 'assets/icons/accessibility.svg';
import cn from 'classnames/bind';
import Link from 'next/link';
import { Col, Row } from 'ui';

import s from './Footer.module.css';
import ShortFooter from './ShortFooter';

const cx = cn.bind(s);
const copyright = `© My personality ${new Date().getFullYear()}`;

const defaultColumns = [{
  md: {
    offset: 1,
    span: 3,
  },
  xs: 6
}, {
  md: 5, xs: 6
}, {
  md: 3
}]
const defaultItems = [
  [{ title: 'Contact', href: '/contact' }, { title: 'Test', href: '/free-personality-test' }, { title: 'Testimonials', href: '/testimonials' }],
  [{ title: 'About us', href: '/about-us' }, { title: 'Pricing', href: '/pricing' }, { title: 'FAQ', href: '/faq' }],
  [{ title: 'Terms & Conditions', href: '/terms-conditions' }, { title: 'Privacy policy', href: '/privacy' },],
]
const Footer = ({ className, short, items = defaultItems, ...attrs }) => (
  <footer className={cx(className, { footerShort: short, footer: !short })} {...attrs}>
    <div className={cx({ container: !short, 'brainable-container': short, shortFooterContainer: short })}>
      {short ? <ShortFooter /> : (
        <>
          <Row className={cx('menus')}>
            {
              defaultColumns.map((column, index) => (
                <Col {...column} key={index}>
                  <nav className={cx('nav')}>
                    <ul className={cx('menu')}>
                      {
                        items[index].map(item => (
                          <li className={cx('menuItem')} key={item.href}>
                            <Link href={item.href}>
                              {item.title}
                            </Link>
                          </li>
                        ))
                      }
                    </ul>
                  </nav>
                </Col>
              ))
            }
          </Row>
          <Row>
            <Col
              md={{
                offset: 1,
                span: 8,
              }}
              xs={7}
            >
              <button className={cx('btn-acsb')} data-acsb-custom-trigger="true">
                <AccessibilityIcon />
              </button>
            </Col>
            <Col md={3} xs={5}></Col>
          </Row>
          <Row>
            <Col
              md={{
                offset: 1,
                span: 8,
              }}
              xs={7}
            >
              {copyright}
            </Col>
            <Col md={3} xs={5}></Col>
          </Row>
        </>
      )}
    </div>
  </footer>
);

export default Footer;
